import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "wrapper-outer",
  style: {
    "line-height": "1.5"
  }
};
const _hoisted_2 = {
  class: "div-086"
};
const _hoisted_3 = {
  class: "position-div"
};
const _hoisted_4 = {
  class: "postion-content"
};
const _hoisted_5 = {
  class: "postion-left"
};
const _hoisted_6 = {
  class: "left-tree"
};
const _hoisted_7 = {
  class: "postion-center"
};
const _hoisted_8 = {
  class: "postion-right"
};
const _hoisted_9 = {
  class: "pos-selected"
};
const _hoisted_10 = {
  class: "pos-selected",
  style: {
    "text-align": "right"
  }
};
const _hoisted_11 = {
  class: "right-div"
};
const _hoisted_12 = {
  class: "pos-selected-left"
};
const _hoisted_13 = {
  class: "pos-selected-right"
};
const _hoisted_14 = {
  class: "submit-div"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_tree = _resolveComponent("el-tree");
  const _component_DArrowRight = _resolveComponent("DArrowRight");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_Delete = _resolveComponent("Delete");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_form = _resolveComponent("el-form");
  const _component_add_aside = _resolveComponent("add-aside");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
    ref: "formRef",
    "label-position": 'top',
    "label-width": "80px",
    model: _ctx.demand,
    rules: _ctx.rules,
    class: "form-div"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      class: "prop-col"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 14
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "需求名称",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            class: "prop-val-row"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _ctx.demand.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.demand.name = $event),
              placeholder: "请输入需求名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "需求人",
          prop: "=userName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            class: "prop-val-row prop-val-text"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.userInfo.userName) + "    " + _toDisplayString($setup.userInfo.depName), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      class: "prop-col"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 14
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          class: "prop-val-row"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "素材计划完成日期",
              prop: "planFinishDate"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_row, {
                class: "prop-val-row"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: _ctx.demand.planFinishDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.demand.planFinishDate = $event),
                  type: "date",
                  "value-format": "YYYY-MM-DD 23:59:59",
                  format: "YYYY-MM-DD",
                  disabledDate: $setup.disabledDate,
                  placeholder: "素材计划完成日期"
                }, null, 8, ["modelValue", "disabledDate"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "素材有效期",
              prop: "validDate"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: _ctx.demand.validDate,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.demand.validDate = $event),
                "value-format": "YYYY-MM-DD HH:mm:ss",
                format: "YYYY-MM-DD",
                type: "daterange",
                disabledDate: $setup.disabledDate,
                "default-time": _ctx.defaultRangeTime,
                "range-separator": "~",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期"
              }, null, 8, ["modelValue", "disabledDate", "default-time"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "联系方式"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            class: "prop-val-row prop-val-text"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, _toDisplayString($setup.userInfo.mobile), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      class: "prop-col"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "需求内容",
        prop: "remark",
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          type: "textarea",
          modelValue: _ctx.demand.remark,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.demand.remark = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form_item, {
      label: "选择投放运营点位",
      prop: "position",
      class: "position-form"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
        modelValue: _ctx.filterText,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.filterText = $event),
        placeholder: "搜索运营位",
        style: {
          "margin-top": "5px"
        }
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createVNode(_component_el_tree, {
        data: _ctx.posTree,
        ref: "treeLeft",
        "show-checkbox": "",
        "node-key": "id",
        "filter-node-method": $setup.filterNode,
        "default-checked-keys": _ctx.defaultPosChecked,
        onCheckChange: $setup.handleCheck,
        props: _ctx.defaultProps
      }, null, 8, ["data", "filter-node-method", "default-checked-keys", "onCheckChange", "props"]), [[_directive_loading, _ctx.positionLoading]])])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
        plain: "",
        type: "primary",
        onClick: $setup.left2right
      }, {
        default: _withCtx(() => [_cache[9] || (_cache[9] = _createTextVNode(" 选中 ", -1)), _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_DArrowRight)]),
          _: 1
        })]),
        _: 1
      }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_row, {
        span: 24,
        class: "right-head-row"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_cache[11] || (_cache[11] = _createTextVNode(" 已选择运营点位 ", -1)), _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          plain: "",
          onClick: $setup.clearPosSelected
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("清空已选", -1)]))]),
          _: 1
        }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_10, [_cache[14] || (_cache[14] = _createTextVNode(" 是否需要源文件 ", -1)), _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          plain: "",
          onClick: _cache[5] || (_cache[5] = $event => $setup.setPosNeedSrc(1))
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("全是", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          plain: "",
          onClick: _cache[6] || (_cache[6] = $event => $setup.setPosNeedSrc(0))
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("全否", -1)]))]),
          _: 1
        })])]),
        _: 1
      }), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positions, (p, i) => {
        return _openBlock(), _createBlock(_component_el_row, {
          class: "right-item",
          key: i
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_icon, {
            size: 15,
            color: "red",
            onClick: $event => $setup.removePosition(i, p.positionId)
          }, {
            default: _withCtx(() => [_createVNode(_component_Delete)]),
            _: 1
          }, 8, ["onClick"]), _createTextVNode(" " + _toDisplayString(p.label), 1)]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_switch, {
            modelValue: p.isUploadSrc,
            "onUpdate:modelValue": $event => p.isUploadSrc = $event,
            "active-text": "是",
            "inactive-text": "否",
            "active-value": 1,
            "inactive-value": 0
          }, null, 8, ["modelValue", "onUpdate:modelValue"])])]),
          _: 2
        }, 1024);
      }), 128))])])])]),
      _: 1
    })])]),
    _: 1
  }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_14, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
    disabled: _ctx.auditLoading,
    type: "primary",
    round: "",
    onClick: _cache[7] || (_cache[7] = $event => $setup.handleSubmit(0))
  }, {
    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("保存草稿", -1)]))]),
    _: 1
  }, 8, ["disabled"])), [[_directive_loading, _ctx.saveLoading]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
    disabled: _ctx.saveLoading,
    type: "primary",
    round: "",
    onClick: _cache[8] || (_cache[8] = $event => $setup.handleSubmit(1))
  }, {
    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("提交审核", -1)]))]),
    _: 1
  }, 8, ["disabled"])), [[_directive_loading, _ctx.auditLoading]])])]), _createVNode(_component_add_aside, {
    procs: $setup.srcProcs
  }, null, 8, ["procs"])], 64);
}